import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  MenuItem,
  Select,
  Checkbox,
  InputBase,
  TextField,
  FormGroup,
  FormControlLabel,
  InputLabel,
  FormControl,
  CardHeader,
  DialogTitle,
  DialogContent,
  DialogContentText,
  CircularProgress
} from "@material-ui/core";
import BackupIcon from '@material-ui/icons/Backup';
import { useDropzone } from "react-dropzone";
import csv from "csvtojson";
import { validateBulkInvites } from "../../../helpers";

export default function BulkSubscriberForm({
  openBulk,
  closeBulk,
  setBulkOpen,
  apiManager,
  uploadedBy,
  openSnack,
  getList
}) {

  //Form variables and handler
  const [fileToProcess, setFileToProcess] = useState('');
  const [processing, setProcessing] = useState(false);

  //validate form and disable/enable submit button
  const [disabled, setDisabled] = useState(true)
  const validateForm = () => {
    if(fileToProcess.length > 0){
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }
  useEffect(() => {
    validateForm();
  }, [fileToProcess]);

  // const bulkUploadUsers = async () => {
  //   setProcessing("uploading");
  //   let csvFile = fileToProcess[0];
  // }

  const bulkUploadUsers = async() => {
   setProcessing('uploading');
   let csvFile = fileToProcess[0];
  
   if (csvFile && csvFile.type) {
      // Ingest CSV within React and convert to JSON
      // Becuase Lambda's don't files/buffers as readily
      // Easier to convert to JSON here.
      let result = null;  
      let reader = new FileReader();   
      reader.readAsText(csvFile);

      // Convert the CSV to JSON and process each invite
      let resultArr = []
      reader.onload = async () => {
        result = reader.result;
        const jsonInvites = await csv().fromString(reader.result);

        // Validate and sanitize bulk invites JSON
        const scrubbedInvites = await validateBulkInvites(jsonInvites, uploadedBy);
        if(!scrubbedInvites.validCSV) openSnack(false, scrubbedInvites.message);

        const userData = scrubbedInvites.data;
        // Traverse bulk invites (w/ special parameter to generate welcome email)
        await Promise.all(userData.map(async (user) => {resultArr.push(await apiManager.adminCreateUser(user, true, true))}));
        let error = false;
        resultArr.forEach((result) => {
          if(typeof result === 'string'){
            error = true
            openSnack(false, result);
          }
        }) 
        if (error === false) {
          openSnack(true, "CSV Bulk Invite Upload was Successful.");
          getList();
        }
      }
    
      // React UI error handling incase CSV coudln't be opened
      reader.onerror = function() {
        // console.log(reader.error);
        openSnack(false, 'Unable to open CSV file. Please contact support for assistance.');
      };
      
      setBulkOpen(false);    
      setProcessing(false);
   }
  }
  const downloadTemplate = () => {
    const csvTemplate = ['PLEASE READ THESE INSTRUCTIONS: Add your data starting in row 4. When you are finished delete lines 1 and 2. Then save your file (in .csv format) and upload.\n NOTES: The only required fields are name (firstName and lastName) and email. The value for each course a user is subscribed to (regenag-101 etc.) should be "yes" (no quotes and lower case).\nfirstName',"lastName","email", "phone", "city", "state", "postalCode", "group", "regenag-101", "grazing", "cropping", "couponCode"]; //set the data
    let csvContent =  "data:text/csv;charset=utf-8," + csvTemplate //combine data with doc type, use map if more than one row
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "UAg_user_upload_template.csv"); //change file name here
    document.body.appendChild(link);
    link.click() //trigger download
  }


//Dropzone uploader
  const RenderUploadFile = props => {
    const {
      getRootProps,
      getInputProps,
      acceptedFiles,
      fileRejections
    } = useDropzone({
      accept: ".csv",
      onDrop: acceptedFiles => {
        setFileToProcess(acceptedFiles);
      }
    });
    return (
      <Grid
        container
        direction="column"
        justify="space-evenly"
        alignItems="center"
        {...getRootProps({})}
        className="file-upload-holder"
      >
        <input {...getInputProps()} />
        <Grid item xs={12} style={{ padding: '14px 0px' }}>
            <BackupIcon style={{fontSize: 30}}/>
        </Grid>
        <Grid item xs={12}>
          <span>Drag and drop here to upload</span>
          <br />
          <p style={{ color: "#6F6F6F", fontSize: 10, textAlign: 'center' }}>CSV files only</p>
        </Grid>
        <Grid item xs={12} style={{ margin: "24px 0px" }}>
          <Button color="primary" variant="contained">
            Or select your files
          </Button>
          {fileToProcess.length > 0 ? (
            <div style={{marginTop: 24}}>
            <span>Current file: <br />{fileToProcess[0].name}</span>
            </div>
          ) : ''
          }
        </Grid>
      </Grid>
    );
  };
  return (
    <Dialog
      open={openBulk}
      onClose={closeBulk}
      fullWidth={true}
      maxWidth={"xs"}
      aria-labelledby="Team Alert"
    >
          <DialogTitle>Bulk Upload Users</DialogTitle>
        {processing
        ?
        <> 
                <div style={{minHeight: 300, padding: 24, textAlign: 'center', marginTop: 100}}>
                    <CircularProgress />
                    <br />
                    {processing}
                </div>
        </>
        :
        <>
        <DialogContent className="file-upload-card-content">
         <DialogContentText>
              Download this <a className="upload__link" onClick={downloadTemplate}>template</a> for list formatting, then
              </DialogContentText>
          <RenderUploadFile />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => 
            {
              setBulkOpen(false); 
              setFileToProcess('')
              }
          }
          className="cancel-button">
            Cancel
          </Button>

          <Button
            onClick={bulkUploadUsers}
            //color={ "primary" }
            variant="text"
            disabled={disabled}
            className={disabled ? "no-upload" : ""}
          >
            Upload Users
          </Button>
        </DialogActions>
        </>
      }

    </Dialog>
  );
}
